import { Box, Button, HStack, SimpleGrid, Spinner, Text, VStack } from '@chakra-ui/react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { Link, useNavigate } from '@tanstack/react-router';
import ContentCard from '@/modules/content/common/ContentCard';
import { getPersonalizedFeedInfiniteOptions } from '@/utils/queryOptions';
import CustomButton from '@/components/atoms/CustomButton';
import { secondary } from '@/theme/colors/palettes';
import svgIcons from '@/assets/svg/icons';

const CuratedContent = () => {
  const { data, isLoading, isError, refetch } = useInfiniteQuery(getPersonalizedFeedInfiniteOptions());
  const content = data?.pages[0]?.data.slice(0, 2) ?? [];

  const navigate = useNavigate();
  const navigateToCuratedContent = () => navigate({ to: '/user/curated-content' });

  return (
    <VStack width="100%" minWidth={0} align="stretch" gap="20px">
      <HStack justify="space-between" align="start" flexWrap="wrap" gap="12px">
        <Box>
          <Text variant="loraMedium22" color="text.darkBlue" textAlign={'start'}>
            Content Curated for You
          </Text>
          <Text color="text.mediumGray" fontWeight={500} mt="6px" fontSize={'14px'}>
            Explore content that helps you become whole.
          </Text>
        </Box>

        <CustomButton
          label="View All"
          iconAfterLabelSvgPath={svgIcons.rightArrow}
          iconAfterLabelSvgColor={'white'}
          width={'177px'}
          iconAfterLabelSvgBoxHeight={14}
          iconAfterLabelSvgBoxWidth={24}
          onClick={navigateToCuratedContent}
          labelColor="extra.white"
          backgroundColor={secondary[500]}
          hoverOpacityDrop
          hoverBackgroundColor={secondary[500]}
          // labelStyle={{ fontSize: 12 }}
          style={{  border: 0 }}
        />
      </HStack>
      {isLoading ? (
        <Spinner color="primary.500" />
      ) : isError ? (
        <Box>
          <Text color="text.mediumBlue">Unable to load curated content.</Text>
          <Button size="sm" onClick={() => refetch()}>
            Try again
          </Button>
        </Box>
      ) : content.length === 0 ? (
        <Text color="text.mediumBlue">No curated content available yet. Check back soon.</Text>
      ) : (
        <SimpleGrid columns={{ base: 1, sm: 2 }} spacing="16px">
          {content.map((item) => (
            <Link key={item.id} to="/loop/$contentId" params={{ contentId: item.id }} style={{ minWidth: 0 }}>
              <ContentCard content={item} size="100%" compact />
            </Link>
          ))}
        </SimpleGrid>
      )}
    </VStack>
  );
};

export default CuratedContent;
